export default {
    selectAll: `Select all %{count} people`,
    bulkSms: {
        title: `New Text`,
        to: `To:`,
        send: `Send Now`,
        sendLater: `Send Later`,
        sending: `Sending...`,
        search: `Search for contacts...`,
        placeholder: `Start typing your text...`,
        linkPhoto: `Link to Photo or File`,
        shortenUrl: `Shorten a URL`,
        charactersRemaining: `%{count} Characters remaining`,
        change: `change`,
        options: {
            sendNow: `Send Now`,
            sendCustom: `Send on custom date and time`,
            sendTomorrow3: `Send tomorrow at 3pm`,
            sendTomorrow9: `Send tomorrow at 9am`,
            sendIn6: `Send in 6 hours`,
            am: `AM`,
            pm: `PM`
        },
        instructions: `When linking to a photo or file, Breeze uses a URL shortener to give you more space to type your message`,
        textRemain: `%{count} Texts Remain this Month`,
        searching: `Searching...`,
        searchContacts: `Search for contacts...`,
        noNumber: `No mobile number`,
        alreadyRecipient: `Already a recipient`,
        loadingContacts: `Loading contacts...`,
        peopleCount: `{count} person | {count} people`,
        notOnMessaging: `can't be texted yet.`,
        success: `Text sent successfully!`,
        onItsWay: `Your text is on its way to {count} person. | Your text is on its way to {count} people.`,
        scheduledFor: `Your text is scheduled for {date} at {time} for {count} person. | Your text is scheduled for {date} at {time} for {count} people.`,
        blastName: `Breeze - People - {time}`,
        date: `Date`,
        time: `Time`,
        validation: {
            mustHaveAtleast: `Must have atleast 1 recipient.`,
            recipientsRequired: `Recipients are required.`,
            messageRequired: `Message is required.`
        },
        errors: {
            nobodyToText: `None of these recipients can receive a text.`,
            timeNotInFuture: `Choose a date and time in the future.`,
            onHold: `Your text wasn't sent because your organization's messaging is under review.`,
            alreadySubmitted: `This text was already submitted, so it wasn't sent again.`,
            recipientsNotReady: `Some of these recipients can't be texted yet, so nothing was sent.`,
            tooLong: `This text is too long to send. Shorten it and try again.`
        },
        error: `Error sending text. Please try again later.`
    },
    enrollTooltip: {
        optIn: `This number has opted in to receive text messages from your organization.`,
        blocked: `This number has blocked your organization from sending text messages to them.`,
        enroll: `Enroll this number to receive text messages from your organization.`,
        enrolledToReceiveText: `Enrolled to Receive Text Messages`,
        status: {
            optIn: {
                title: `Enrolled to Receive Text Messages`,
                tooltip: `This number has opted-in to receive Text Messages from your organization.`
            },
            blocked: {
                title: `Blocked from Receive Text Messages`,
                tooltip: `This number has blocked your organization from sending Text Messages to them.`
            },
            notEnrolled: {
                title: `Not Enrolled for Text Messages`,
                tooltip: `This number needs to be enrolled to receive Text Messages.`
            }
        },
        failedToEnroll: {
            title: `There was an error, please try again`,
            tooltip: `There was a problem fetching or enrolling this number.`
        },
        loading: `Loading...`
    },
    filters: {
        shared: `Visible to everyone in organization`,
        private: `Only visible to me`,
        sharedLabel: `Shared filter`,
        privateLabel: `Private filter`,
        applyFilter: `Apply Filter`,
        edit: `Edit`,
        deleteModal: {
            title: `Delete Saved Filter`,
            confirmText: `Are you sure you want to delete the filter '{name}'? This action cannot be undone.`,
            confirmButton: `Delete`,
            successMessage: `Saved filter deleted successfully`,
            errorMessage: `Error deleting saved filter`
        },
        menuItems: {
            properties: `Properties`,
            delete: `Delete`
        },
        // Chip wording for the `*` / `!` presence shortcuts (BRZE-5819). `field`
        // is the filter's own label — a profile field name, or one of the
        // fallbacks below when the field can't be resolved.
        presence: {
            hasAny: `{field}: Has any`,
            none: `{field}: None`,
            email: `Email`,
            notes: `Notes`,
            phone: `Phone`,
            text: `Text`
        }
    },
    addFamilyMember: {
        title: `Add Family Member`,
        options: {
            newPerson: {
                title: `New Person`,
                description: `Add a new person to the database as a member of this family.`
            },
            existingPerson: {
                title: `Existing Person`,
                description: `Select a person already in the database to associate as a family member.`
            }
        },
        cancel: `Cancel`
    },
    addPersonModal: {
        title: `Add Person`,
        subtitle: `Add a new person to the database.`,
        failedToAdd: `Failed to add person please try again later`,
        addSuccess: `Person added successfully.`,
        continueAdding: `Continue adding people`,
        cancel: `Cancel`,
        save: `Save`,
        loadingTags: `Loading Tags...`,
        householdRole: `Household Role`,
        addAnotherPersonToManageFamily: `Add another person in order to manage family information`,
        uploading: `Uploading...`,
        familyMembers: `Family Members`,
        family: `Family`,
        addFamilyMember: `Add Family Member`,
        addPerson: `Add Person`,
        removeImage: `Remove Image`,
        duplicateWarning: `Potential Duplicates:`,
        failedToAssignFollowUps: `Failed to assign follow ups to person`,
        confirmClosing: `Are you sure you want to continue closing out of Add Person? Any changes you have made will not be saved.`
    },
    addFamilyMemberSearch: {
        title: `Add Family Member`,
        searchPlaceholder: `Search for a person...`,
        personNotFound: 'Person Not Found',
        selectDifferent: 'Select a different person',
        addFamilyMember: 'Add Family Member',
        cancel: `Cancel`,
        noPerson: `No person or family selected to add`,
        familyMemberAdded: `Family member added successfully`,
        familyMembersAdded: `%{count} family members added successfully`,
        addFailed: `Failed to add family members. Please try again.`
    },
    displayFields: {
        title: `Display Fields`,
        instructions: `Select the profile fields you'd like to include when adding new people. These preferences will be saved for your user. In order to add additional field options, you will need to add a custom field in the Profile Fields section.`
    },
    exportPeopleModal: {
        title: `Export People`,
        download: `Download`,
        downloadFallback: `Click here if download doesn't start`,
        cancel: `Cancel`,
        confirmText: ``,
        successUpdate: `Updated people successfully`,
        errorUpdate: `Failed to update people.`,
        downloadError: `Failed to download export.`
    },
    bulkUpdateModal: {
        title: `Bulk Update People`,
        subtitle: `This action will update all selected profiles with the information provided below.`,
        header: `Applies to:`,
        subHeader: `1 person | %{peopleCount} people`,
        subHeaderContent: `selected from your list`,
        confirmText: `Update`,
        successUpdate: `Updated people successfully`,
        errorUpdate: `Failed to update people.`,
        setByGraduationYear: `Set by Graduation Year`,
        setByGrade: `Set by Grade`
    },
    bulkArchiveModal: {
        title: `Bulk Archive People`,
        personConfirmButton: `Archive %{count} Person | Archive %{count} People`,
        confirmText: `Archiving people will remove them from the main People page, general search results, and family member profiles. All of their information will be maintained and accessible. This action can be undone.

        Applies to:
        %{count} person selected from your list |

        Archiving people will remove them from the main People page, general search results, and family member profiles. All of their information will be maintained and accessible. This action can be undone.

        Applies to:
        %{count} people selected from your list`,
        successArchive: `Archived people successfully`,
        errorArchive: `Failed to archive people.`
    },
    archiveModal: {
        title: `Archive Person`,
        titleUnarchive: `Unarchive Person`,
        confirmButton: `Archive`,
        confirmButtonUnarchive: `Unarchive`,
        learnMore: `Learn More`,
        cancel: `Cancel`,
        confirmText: `Do you really want to archive this person?`,
        confirmTextUnarchive: `Do you really want to unarchive this person?`,
        successArchive: `Archived person successfully`,
        successUnarchive: `Unarchived person successfully`,
        errorArchive: `Failed to archive person.`,
        errorUnarchive: `Failed to unarchive person.`
    },
    bulkUnarchiveModal: {
        title: `Bulk Unarchive People`,
        personConfirmButton: `Unarchive %{count} Person | Unarchive %{count} People`,
        confirmText: `Unarchiving people will add them back into the main People page, general search results, family member profiles, and the Tags they were in before being archived.

        Applies to: %{count} person selected from your list |

        Unarchiving people will add them back into the main People page, general search results, family member profiles, and the Tags they were in before being archived.

        Applies to: %{count} people selected from your list`,
        successArchive: `Unarchived people successfully`,
        errorArchive: `Failed to unarchive people.`
    },
    bulkDeleteModal: {
        onConfirmError: `An error occurred while deleting people.`,
        onConfirmSuccess: `Person deleted successfully.`,
        title: `Bulk Delete People`,
        content: `We are no longer allowing delete from a member profile as this action is not recommended. Therefore, the profile will be moved to Archive. If you wish to fully delete the record, please select the delete option from the Archive page.`,
        recordsWarning: `Please note deleted records cannot be restored.`,
        recordsWarningDelete: `Contributions records for these people will be marked as anonymous.`,
        recordsWarningPartTwo: `In total, this 1 person has | In total, these %{peopleCount} people have`,
        recordsWarningPartThree: `1 giving record | %{givingCount} giving records`,
        givingRecords: `giving records`,
        confirmButton: `Archive | Archive %{peopleCount} People`,
        confirmButtonDelete: `Delete | Delete %{peopleCount} People`,
        header: `Applies to:`,
        subHeader: `1 person | %{peopleCount} people`,
        subHeaderContent: `selected from your list`,
        warning: `Deleting people will remove them and all of their information from Breeze. This action can be undone for 30 days.`
    },
    bulkAssignToTagsModal: {
        title: `Assign to Tags`,
        subtitle: `This action will add individuals to selected Tags.`,
        confirmButton: `Assign`,
        header: `Applies to:`,
        secondHeader: `Tag Selection:`,
        subHeader: `1 person | %{peopleCount} people`,
        subHeaderContent: `selected from your list`,
        successUpdate: `People Assigned to tags successfully`,
        errorUpdate: `Failed to assign people to tags.`
    },
    bulkRemoveFromTagsModal: {
        title: `Remove from Tags`,
        subtitle: `This action will remove individuals from selected Tags. They will be removed from any area of Breeze where you are segmenting with selected Tags.`,
        subtitleWarning: `This cannot be undone.`,
        confirmButton: `Remove`,
        header: `Applies to:`,
        secondHeader: `Tag Selection:`,
        subHeader: `1 person | %{peopleCount} people`,
        subHeaderContent: `selected from your list`,
        successUpdate: `People removed from tags successfully`,
        errorUpdate: `Failed to remove people from tags.`
    },
    inbox: {
        markReadError: `We couldn't mark this conversation as read. It will stay in your inbox for now.`,
        welcome: {
            title: `Welcome to Inbox`,
            beta: `BETA`,
            description: `You can now send and receive text messages to individuals from their profile using Tithely Inbox. Tell us what you'd like to see next!`,
            feedback: `Give feedback`
        },
        empty: {
            title: `You haven't sent any messages to %{name}, yet!`,
            titleFallback: `You haven't sent any messages, yet!`,
            description: `When you send a text to someone, it will appear here along with any responses.`
        },
        composer: {
            placeholder: `Type your message`,
            url: `URL`,
            send: `Send text`,
            smsUsage: `SMS Usage`,
            usageCount: `%{used} / %{limit}`,
            tier: `Tier %{tier}`,
            sendError: `We couldn't send your message. Please try again.`,
            markReadError: `We couldn't mark this conversation as read. It will stay in your inbox for now.`,
            textsRemain: `%{count} texts remain this month`,
            noMobileNumber: `%{name} doesn't have a mobile number we can text. Add one to their profile to start a conversation.`,
            noMobileNumberFallback: `This person doesn't have a mobile number we can text. Add one to their profile to start a conversation.`,
            numberUnavailable: `This number is shared by multiple members. In order to send a message, it must be associated with a single person.`
        }
    },
    person: {
        noInfo: `No information stored.`,
        noContactInfoAvailable: `No contact information available.`,
        familyRole: {
            unassigned: `Unassigned`,
            child: `Child`,
            adult: `Adult`,
            headOfHousehold: `Head of Household`,
            spouse: `Spouse`
        },
        clickToEditSection: `click to edit this section`,
        save: `Save`,
        cancel: `Cancel`,
        phoneInput: {
            showMore: `Show More Options`,
            showFewer: `Show Fewer Options`,
            doNotText: `Do Not Text`,
            doNotTextGroupTexts: `Exclude from Group Texts`,
            makePrivate: `Make Private`,
            private: `Private`,
            makePrivateTooltip: `Only users with permission to view private data will be able to see this.`,
            validation: {
                invalidFormat: `Invalid %{type} phone number format`
            }
        },
        addressInput: {
            showMore: `Show More Options`,
            showFewer: `Show Fewer Options`,
            applyAddressToAll: `Apply address changes to all family members`,
            makePrivate: `Make Private`,
            private: `Private`,
            validation: {
                invalidFormat: `Invalid %{field} format`
            }
        },
        emailInput: {
            showMore: `Show More Options`,
            showFewer: `Show Fewer Options`,
            doNotEmail: `Do Not Email`,
            makePrivate: `Make Private`,
            private: `Private`,
            validation: {
                invalidFormat: `Invalid email format`
            }
        },
        gradeInput: {
            setByGraduationYear: `Set by Graduation Year`,
            setByGrade: `Set by Grade`,
            grade: `Grade`,
            graduationYear: `Graduation Year`
        },
        nameField: {
            nameMissingError: `A person must have either a First Name, Nickname, or Last Name in order to be added.`
        }
    },
    conflictingPhoneNumbersModal: {
        title: 'Conflicting Phone Numbers',
        description:
            'One or more family members have conflicting phone numbers. Select 1 correct phone number or continue with different addresses.',
        keepDifferent: 'Keep different phone numbers',
        updateAllTo: 'Update all phone numbers to:',
        noPhone: 'No phone on file.',
        assignedTo: 'Currently assigned to %{names}',
        cancel: 'Cancel',
        confirm: 'Confirm'
    },
    conflictingAddressesModal: {
        title: 'Conflicting Addresses',
        description:
            'One or more family members have conflicting addresses. Select 1 correct address or continue with different addresses.',
        keepDifferent: 'Keep different addresses',
        updateAllTo: 'Update all addresses to:',
        assignedTo: 'Currently assigned to %{names}',
        cancel: 'Cancel',
        confirm: 'Continue'
    },
    linkedProfile: `This profile is linked to a user`,
    notes: {
        title: 'Notes',
        addNote: 'Add Note',
        addFirstNote: 'Add First Note',
        editNote: 'Edit Note',
        edit: 'Edit',
        delete: 'Delete',
        noNotesYet: 'No notes yet',
        addFirstNoteDescription: 'Add the first note for this person.',
        loadingNotes: 'Loading notes...',
        notesDataNotAvailable: 'Notes data not available. Please check the API configuration.',
        unknownUser: 'Unknown User',
        privateNoteTooltip: 'Private Note: Only you can see this note.',
        noNotesSaved: 'There are no notes saved for this person.',
        noteTextPlaceholder: 'Enter your note here...',
        markAsPrivate: 'Mark as Private (so only you can see this note)',
        cancel: 'Cancel',
        save: 'Save',
        noteSaved: 'Note saved successfully',
        noteSaveFailed: 'Failed to save note',
        noteUpdated: 'Note updated successfully',
        noteUpdateFailed: 'Failed to update note',
        deleteConfirmTitle: 'Delete Note',
        deleteConfirmText: 'Are you sure you want to delete this note? This action cannot be undone.',
        deleteConfirmButton: 'Delete Note'
    },
    personUpdate: {
        success: 'Person updated successfully',
        failed: 'Update failed. Please try again.'
    },
    familyField: {
        householdRole: 'Household Role',
        addAnotherPerson: 'Add another person in order to manage family information',
        remove: 'Remove',
        familyMembers: 'Family Members',
        noFamilyMembers: 'No family members found',
        addFamilyMember: 'Add Family Member',
        selectFamilyPicture: 'Select Family Picture',
        currentFamilyPhoto: 'Current family photo',
        noFamilyPicture: 'No family picture',
        upload: 'Upload',
        uploadDescription: 'Upload your own image to use as the family picture.',
        uploadImage: 'Upload Image',
        selectImageFile: 'Select image file',
        removeFamilyPicture: 'Remove Family Picture',
        removeMember: {
            confirmTitle: 'Remove Person',
            confirmText: 'Are you sure you want to remove {name} from the family?',
            confirmButton: 'Remove Person'
        },
        removeSuccess: 'Successfully removed person'
    },
    assignTagsModal: {
        title: `Assign/Unassign Tags`,
        subtitle: `Select the tags you wish to be assigned to this person.`,
        confirmButton: `Save`,
        successUpdate: `Person assigned to tags successfully`,
        errorUpdate: `Failed to assign person to tags.`
    },
    tags: {
        title: 'Tags',
        addTag: 'Assign/Unassign Tags',
        addTagAriaLabel: 'Open dialog to assign or unassign tags for this person',
        noTagsYet: 'This person is not assigned to any tags.',
        loadingTags: 'Loading tags...',
        mainContentAriaLabel: 'Person tags management area',
        emptyStateAriaLabel: 'No tags assigned. This person is not currently assigned to any tags.',
        cancel: 'Cancel',
        save: 'Save'
    },
    tagsColumn: {
        overflow: `+%{count} more`
    },
    savedFilter: {
        common: {
            filterName: 'Filter Name',
            filterDescription: 'Filter Description',
            visibility: 'Visibility',
            onlyVisibleToMe: 'Only visible to me',
            makeVisibleToOthers: 'Make visible to others in my organization',
            visibilityTooltip:
                'Any user at your organization who has permission to view these filter fields will have access to this saved filter.',
            cancel: 'Cancel',
            save: 'Save',
            saving: 'Saving',
            nameRequired: 'The filter name field is required'
        },
        addModal: {
            title: 'Add Saved Filter',
            successMessage: 'Saved filter created successfully',
            errorMessage: 'Error creating saved filter'
        },
        editModal: {
            title: 'Edit Saved Filter',
            successMessage: 'Saved filter updated successfully',
            errorMessage: 'Error updating saved filter'
        }
    },
    ministrySafe: {
        widget: {
            activate: `Activate Background Checks`,
            orderBackgroundCheck: `Order Background Check`,
            orderTraining: `Order Training`,
            viewProfile: `View MinistrySafe profile`,
            backgroundCheck: `Background check`,
            passed: `Passed`,
            failed: `Failed`,
            assigned: `Assigned`,
            noEmail: `An email is required for background checks and trainings.`,
            noBirthdate: `A birthday is required for background checks.`,
            tooYoung: `Background checks are not supported for people under 13.`
        },
        orderBackgroundCheckModal: {
            title: `Order Background Check`,
            step: `Step %{current} of %{total}`,
            confirmPrompt: `Order a %{level} for %{person}?`,
            employeeTypeLabel: `This person is`,
            userTypeLabel: `Serving as`,
            childServing: `This person works with children or youth`,
            current: `Current`,
            prospective: `Prospective`,
            staff: `Staff`,
            volunteer: `Volunteer`,
            cost: `Cost`,
            childServingSummary: `Works with children or youth`,
            yes: `Yes`,
            no: `No`,
            billingNotice: `Your organization is billed when this order is placed.`,
            cancel: `Cancel`,
            continue: `Continue`,
            submit: `Place Order`,
            success: `Background check ordered.`,
            error: `The background check could not be ordered. Please try again.`,
            levelsError: `Background check options could not be loaded. Please try again.`
        },
        assignTrainingModal: {
            title: `Order Training`,
            stepTraining: `Choose a training`,
            stepFocus: `Choose a focus`,
            stepConfirm: `Confirm`,
            confirmPrompt: `Assign %{training} to %{person}?`,
            cost: `Cost`,
            assignedTo: `Assigned to`,
            billingNotice: `MinistrySafe emails this person a link to take the training. Your organization is billed when it is assigned.`,
            cancel: `Cancel`,
            continue: `Continue`,
            submit: `Assign Training`,
            success: `Training assigned.`,
            error: `The training could not be assigned. Please try again.`,
            surveysError: `Training choices could not be loaded. Please try again.`
        },
        activateModal: {
            title: `Activate MinistrySafe`,
            stepIntro: `Add MinistrySafe to your account`,
            stepDetails: `How it works`,
            stepProvisioning: `Setting things up`,
            stepDone: `All set`,
            intro: `MinistrySafe provides background checks and abuse-awareness training for your staff and volunteers. Activating adds it to your Tithe.ly account so you can order both from a person's profile in Breeze.`,
            howItWorks: `How it works`,
            howItWorksProfile: `Order background checks and trainings directly from a person's profile.`,
            howItWorksStatus: `See the status of someone's background checks and trainings without leaving Breeze.`,
            whatItCosts: `What it costs`,
            costsBackgroundChecks: `Background checks start at $10.`,
            costsTrainings: `Trainings start at $2.`,
            costsInvoice: `Charges are included in your monthly Tithe.ly invoice.`,
            agreementPrefix: `I understand and agree that the`,
            agreementLink: `Member Service Agreement`,
            agreementSuffix: `governs my access to and use of the MinistrySafe background service.`,
            provisioning: `Setting up your MinistrySafe account...`,
            done: `MinistrySafe is now active on your account. You can order a background check or a training from any person's profile.`,
            pending: `MinistrySafe is still being set up. Refresh the page if the order buttons don't appear.`,
            cancel: `Cancel`,
            start: `Activate new MinistrySafe account`,
            submit: `Activate MinistrySafe`,
            finish: `Done`,
            success: `MinistrySafe activated.`,
            error: `MinistrySafe could not be activated. Please try again or contact support.`
        }
    }
}
